import ActionTypes from '../constants/ActionTypes';

const initialState = {
  rebootSystemError: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.REBOOT_SYSTEM_SUCCEEDED:
    case ActionTypes.REBOOT_SYSTEM_FAILED:
      return {
        ...state,
        rebootSystemError: !payload.success,
      };
    case ActionTypes.SYSTEM_ERROR_CLEAR:
      return {
        ...state,
        rebootSystemError: null,
      };
    default:
      return state;
  }
};
